import { PendingScreen } from '../PendingScreen';
import { uploadErrorType } from './fileUploadUtils';
import React from 'react';

interface Props {
  setDisplayOverlay: (value: boolean) => void;
  errorType?: uploadErrorType;
  hideClose?: boolean;
}

export const PendingOverlayScreen: React.FC<Props> = ({ setDisplayOverlay }) => {
  return (
    <div className={`fixed inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center z-50`}>
      <div className="bg-white shadow-custom p-5">
        <PendingScreen closeFunction={() => setDisplayOverlay(false)} />
      </div>
    </div>
  );
};
